<app-side-dialog class="min-w-[700px]" [disableClose]="store.briefAnalyzeLoading$()">
  <div dialogHeader>
    <h2>{{ title() }}</h2>
  </div>

  <div dialogContent>
    <form class="custom-form flex flex-col gap-10" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="flex flex-col gap-4">
        <mat-form-field>
          <input matInput formControlName="name" [placeholder]="'field.name' | translate" />
          <mat-error [control]="form.get('name')" />
        </mat-form-field>

        <app-file-uploader
          class="w-full"
          size="big"
          [imageWidth]="80"
          [imageHeight]="80"
          [title]="'dialogs.createCampaignDialog.selectCampaignIconOptional' | translate"
          [description]="'dialogs.createCampaignDialog.iconDescription' | translate"
          [imageId]="form.controls.iconId.value"
          [fileForm]="form.controls.imageFile"
          [requiredPermission]="[EPermissions.campaignCreate]"
          (imageSelected)="onImageSelected($event)"
          (imageRemoved)="onImageRemoved()"
          #fileUploaderComponent
        />
      </div>

      @if (showBriefUploader()) {
        <div class="flex items-center gap-3">
          <hr class="flex-1 border-shikenso-purple-base-12" />
          <span class="text-shikenso-purple-base-60 text-sm">{{ 'dialogs.createCampaignDialog.or' | translate }}</span>
          <hr class="flex-1 border-shikenso-purple-base-12" />
        </div>

        <div class="flex flex-col gap-4">
          <app-file-uploader
            class="w-full"
            size="big"
            [imageWidth]="80"
            [imageHeight]="80"
            [title]="'dialogs.createCampaignDialog.uploadBriefing' | translate"
            [fileExtensions]="['pdf', 'docx', 'txt']"
            [fileForm]="form.controls.briefFile"
            [uploadRequest]="briefFileUploadStub"
            [requiredPermission]="[EPermissions.campaignCreate]"
          />
        </div>
      }

      <div class="flex justify-end gap-3">
        <button
          mat-flat-button
          color="secondary-transparent"
          type="button"
          [disabled]="store.campaignSubmitLoading$() || submitButtonLoading()"
          (click)="onCloseClick()"
        >
          {{ 'shared.cancel' | translate }}
        </button>

        <button
          mat-flat-button
          type="submit"
          [disabled]="!form.valid || store.campaignSubmitLoading$() || submitButtonLoading()"
        >
          <p [class.hidden]="submitButtonLoading()">{{ submitButtonText() }}</p>

          @if (submitButtonLoading()) {
            <app-dots-spinner />
          }
        </button>
      </div>
    </form>
  </div>
</app-side-dialog>

<ng-template #briefAnalyzingOverlay>
  <div
    class="fixed inset-0 flex items-center justify-center bg-black/40"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'dialogs.createCampaignDialog.analyzingBrief' | translate"
    cdkTrapFocus
    cdkTrapFocusAutoCapture
  >
    <div class="relative flex flex-col items-center gap-5 bg-shikenso-base-white rounded-[24px] px-14 py-10">
      <button
        type="button"
        class="absolute top-4 right-4"
        (click)="onCancelBriefAnalyze()"
        [attr.aria-label]="'shared.close' | translate"
      >
        <app-icon src="/icons/close.svg" [size]="20" />
      </button>

      <p class="text-shikenso-purple-base text-xl font-medium text-center max-w-xs">
        {{ 'dialogs.createCampaignDialog.analyzingBrief' | translate }}
      </p>

      <app-dots-spinner />
    </div>
  </div>
</ng-template>
